import { render, staticRenderFns } from "./EquipmentData.vue?vue&type=template&id=2d483a3d&scoped=true"
import script from "./EquipmentData.vue?vue&type=script&lang=js"
export * from "./EquipmentData.vue?vue&type=script&lang=js"
import style0 from "./EquipmentData.vue?vue&type=style&index=0&id=2d483a3d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d483a3d",
  null
  
)

export default component.exports